import React, { useEffect , useState, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { Modal } from 'react-responsive-modal';
import { sliderList, programList, projectList, eventList, videoList, audioList } from "../actions/api-home";
import { recentList } from "../actions/api-gallery";
import { SRLWrapper  } from "simple-react-lightbox";
import Swiper, { Navigation, Pagination, Autoplay  } from 'swiper';
import ReactTooltip from "react-tooltip";
import { ToastContainer, toast } from 'react-toastify';
import 'react-responsive-modal/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import { useWish } from '../hooks';

import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';

const Home = (props) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [videourl, setVideourl] = useState('');  
  const sliders = useSelector(state => state),
  { homeReducer } = sliders,
  { slider_lists, program_lists, project_lists, event_lists, video_lists, audio_lists } = homeReducer;

  const gallery = useSelector(state => state),
    { galleryReducer } = gallery,
    { recent_lists } = galleryReducer;

  const options = {
    buttons: {
      showDownloadButton: false,
    }
  }

  const dispatch = useDispatch();
  const [recent,setRecent]=useState([]);
  const [sliderLists,setSliderLists]=useState([]);
  const [bottombanner,setBottomBanner]=useState(null);
  const [programLists,setProgramLists]=useState([]);
  const [projects,setProjects]=useState([]);
  const [karmayogam,setKarmayogam]=useState(null);
  const [programevent,setProgramEvent]=useState([]);
  const [eventLists,setEventLists]=useState([]);
  const [videoLists,setVideoLists]=useState([]);
  const [audioLists,setAudioLists]=useState([]);
  const [albumcount,setAlbumCount]=useState(0);
  useEffect(() => {
    document.title = "Home | Matangi";
    localStorage.removeItem("navtype");
    localStorage.removeItem("event_id");
    dispatch(sliderList());
    dispatch(programList());
    dispatch(projectList());
    dispatch(eventList());
    dispatch(videoList());
    dispatch(audioList());
    dispatch(recentList());
  }, [dispatch]);

  useEffect(() => {
    if(!isEmpty(slider_lists.data)){
      setSliderLists(slider_lists.data);
      setBottomBanner(slider_lists.bottombanner);
    }
    if (!isEmpty(program_lists.data)) {
      setProgramLists(program_lists.data);
      setKarmayogam(program_lists.karmayogam);
      setProgramEvent(program_lists.programevent);
    }
    if (!isEmpty(project_lists.data)) {
      setProjects(project_lists.data);
    }
    if (!isEmpty(event_lists.data)) {
      setEventLists(event_lists.data.slice(0, 20));
    }
    if (!isEmpty(video_lists.data)) {
      setVideoLists(video_lists.data.slice(0, 20));
    }
    if (!isEmpty(audio_lists.data)) {
      setAudioLists(audio_lists.data.slice(0, 20));
    }
    if (!isEmpty(recent_lists.data)) {
			setRecent(recent_lists.data.slice(0, 8));
      setAlbumCount(recent_lists.album_count);
		}
  }, [slider_lists, program_lists, project_lists, event_lists, video_lists, audio_lists, recent_lists]);

  const onOpenModal = (e) => {
    var videlink = e.currentTarget.dataset.video;
    setVideourl(videlink);
    setOpen(true);
  };

  const onMandir = (e) => {
    var videlink = '<iframe width="560" height="315" src="https://www.youtube.com/embed/yVutd1rbwdQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    setVideourl(videlink);
    setOpen(true);
  };

  const onCloseModal = () => setOpen(false);

  const handleRegister = (e) => { 
      let program_id = e.target.dataset.programid;
      let event_id = e.target.dataset.eventid;
      localStorage.setItem("navtype", program_id);
      localStorage.setItem("event_id", event_id);
      if(program_id =='1'){
        props.history.push("/ulchemy");
        window.location.reload();
      }
      if(program_id =='2'){
        props.history.push("/ulchemy-elite");
        window.location.reload();
      }
      if(program_id =='3'){
        props.history.push("/divija");
        window.location.reload();
      }
      if(program_id =='4'){
        props.history.push("/kaivalya");
        window.location.reload();
      }
      if(program_id =='5'){
        props.history.push("/vision");
        window.location.reload();
      }
      if(program_id =='6'){
        props.history.push("/shivratri");
        window.location.reload();
      }
      if(program_id =='7'){
        props.history.push("/karmayogam");
        window.location.reload();
      }
      if(program_id =='8'){
        props.history.push("/paradesham");
        window.location.reload();
      }
      
  };

  const onClickTile = (e) => {
    var source = e.currentTarget.getAttribute("data-source");
    history.push(`/programs/${source}`);
  };

  Swiper.use([Navigation, Pagination, Autoplay ]);
  
  //const swiperhead = useRef(null)
  
  // swiperhead.current = new Swiper('.banner-slider-container', {
  //   modules: [ Pagination, Autoplay ],
  //   slidesPerView: 1,
  //   loop: true,
  //   autoplay:{delay: 2000, disableOnInteraction: false },
  //   spaceBetween: 0,
  //   speed: 2000,
  //   pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true,
  //   }
  // });
  const AutoplaySlider = withAutoplay(AwesomeSlider);


  let [swiperone, setSwiperOne] = useState(null) 
  useEffect(() => {
    if(!isEmpty(audioLists)) {
      let swiperone= new Swiper('.audio-container', {
        modules: [ Navigation ],
        slidesPerView: 4,
        centeredSlides:false,
        loop: false,
        navigation: {
            nextEl: '.audio-slider-next',
            prevEl: '.audio-slider-prev',
          },
        spaceBetween: 10,
        breakpoints: {
            1200: {
                slidesPerView: 4
            },
            990: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 2
            },
            540: {
                slidesPerView: 1
            },
            400: {
                slidesPerView: 1
            },
            360: {
                slidesPerView: 1
            }
        }
      });
    setSwiperOne(swiperone) 
  }
  }, [audioLists])

  let [swipertwo, setSwiperTwo] = useState(null) 
  useEffect(() => {
    if(!isEmpty(videoLists)) {
      let swipertwo = new Swiper('.video-container', {
        modules: [ Navigation ],
        slidesPerView: 4,
        centeredSlides:false,
        loop: false,
        navigation: {
            nextEl: '.video-slider-next',
            prevEl: '.video-slider-prev',
          },
        spaceBetween: 10,
        breakpoints: {
            1200: {
                slidesPerView: 4
            },
            990: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 2
            },
            540: {
                slidesPerView: 1
            },
            400: {
                slidesPerView: 1
            },
            360: {
                slidesPerView: 1
            }
        }
      });
      setSwiperTwo(swipertwo) 
  }
  }, [videoLists])

  let [swiperthree, setSwiperThree] = useState(null) 
  useEffect(() => {
    if(!isEmpty(eventLists)) {
      let swiperthree = new Swiper('.upcomingevent-container', {
        modules: [ Navigation ],
        slidesPerView: 4,
        centeredSlides:false,
        loop: false,
        navigation: {
            nextEl: '.upcomingevent-slider-next',
            prevEl: '.upcomingevent-slider-prev',
          },
        spaceBetween: 10,
        breakpoints: {
            1200: {
                slidesPerView: 4
            },
            990: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 2
            },
            540: {
                slidesPerView: 1
            },
            400: {
                slidesPerView: 1
            },
            360: {
                slidesPerView: 1
            }
        }
      });
      setSwiperThree(swiperthree) 
  }
  }, [eventLists])

  const onClickSlider = (e) => {
      var source = e.currentTarget.getAttribute("data-source");
      if(source !=null){
        window.open(source,'_blank');
        // window.location.href = source;
      }
      
  };

  const copyToClipBoard = async copyMe => {
    try {
      var link = copyMe.match(/\bhttps?:\/\/\S+/gi);
      var final_link = link[0].replace(/^"|"$/g, '');
      await navigator.clipboard.writeText(final_link);
      toast('Link Copied Successfully', {
        theme: "dark"
      });
    } catch (err) {

    }
  };

  const [shareopen, setShareOpen] = useState(false);
	const [sharelink, setShareLink] = useState('');

  const copyToClipEventBoard = async copyMe => {
    try {
      if(copyMe =='1'){
        var links = `${window.location.origin.toString()}/ulchemy`;
      }
      if(copyMe =='2'){
        var links = `${window.location.origin.toString()}/ulchemy-elite`;
      }
      if(copyMe =='3'){
        var links = `${window.location.origin.toString()}/divija`;
      }
      if(copyMe =='4'){
        var links = `${window.location.origin.toString()}/kaivalya`;
      }
      if(copyMe =='5'){
        var links = `${window.location.origin.toString()}/vision`;
      }
      if(copyMe =='6'){
        var links = `${window.location.origin.toString()}/shivratri`;
      }
      if(copyMe =='7'){
        var links = `${window.location.origin.toString()}/karmayogam`;
      }
      if(copyMe =='8'){
        var links = `${window.location.origin.toString()}/paradesham`;
      }
      setShareLink(links)
      setShareOpen(true);
      await navigator.clipboard.writeText(links);
      toast('Link Copied Successfully', {
        theme: "dark"
      });
    } catch (err) {

    }
  };

  const { isMediaOnWish, isEventOnWish, addToMediaWish, addToEventWish } = useWish();
  const addMedia = (e) => {
    var source = e.currentTarget.getAttribute("data-id");
    addToMediaWish(source);
  };
  const addEvent = (e) => {
    var source = e.currentTarget.getAttribute("data-id");
    addToEventWish(source);
  };
  
  const feedcheck = localStorage.getItem("reg_id");
    if(feedcheck !=0){
      const program_id = localStorage.getItem("regprogram_id");
      if(program_id ==1){
        props.history.push("/ulchemy-feedback");
        window.location.reload();
      }
      if(program_id ==2){
        props.history.push("/ulchemyelite-feedback");
        window.location.reload();
      }
      if(program_id ==3){
        props.history.push("/divija-feedback");
        window.location.reload();
      }
      if(program_id ==4){
        props.history.push("/kaivalya-feedback");
        window.location.reload();
      }
      if(program_id ==5){
        props.history.push("/vision-feedback");
        window.location.reload();
      }
  }

  
	const onShareOpenModal = async copyMe => {
      try {
    var link = copyMe.match(/\bhttps?:\/\/\S+/gi);
    var final_link = link[0].replace(/^"|"$/g, '');
    setShareLink(final_link)
    setShareOpen(true);
    await navigator.clipboard.writeText(final_link);
    toast('Link Copied Successfully', {
      theme: "dark"
    });
    
      } catch (err) {
  
      }
  };
  const onShareCloseModal = () => setShareOpen(false);

  return (
    <div>
    <section className="page_mainslider">
      <div className="banner-slider-container">
        <AutoplaySlider play={true} bullets={true} interval={6000}>
          { sliderLists.length>0 ? sliderLists.map((slider, sssindex) => (
              <div data-src={slider.image} onClick={onClickSlider} data-source={slider.media} key={sssindex}/>
          )) : 
              <div></div>
          }
        </AutoplaySlider>

          {/* <div className="swiper-wrapper">
              { sliderLists.length>0 ? sliderLists.map((slider, index) => (
                  <div className="swiper-slide" key={`banner-skeleton ${index}`}>
                      <div className="banner-content-area">
                        <div className="banner-image" style={{ backgroundImage: `url(${slider.image})` }}></div>
                      </div>
                  </div>
              )) : 
                  <div></div>
              }
          </div> */}
      </div>
    </section>

    <section className="section-divider">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="divider-populated">
              <div className="mantan-m-holder">
                    <div className="mantan-m-line"></div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
                      <g fill="none" stroke="#44d5bf" strokeMiterlimit="10">
                        <path d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path>
                        <path d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path>
                      </g>
                      <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path>
                      <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path>
                    </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section whois">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="title-sec">
              <h1 className="text-center">Goddess Raja Matangi Devi</h1>
            </div>
          </div>
          <div className="col-md-6">
            <div className="whois-content">
              <p style={{"textAlign":"justify"}}>Goddess Raja Matangi Devi is an extremely powerful avatar of Shakti (Divine feminine energy). She is the ninth of Dasha Mahavidyas (the Great Cosmic Wisdom) and  a  combined form of Tri-Shaktis (Lakshmi, Saraswati and Parvati) representing wealth, wisdom and courage. Goddess Matangi bestows the wisdom for attaining fulfillment in the materialistic world and the wisdom to attain Self-Realization.</p>
              <p style={{"textAlign":"justify"}}>Goddess Raja Matangi Devi is the goddess of music and learning. She governs speech, music, knowledge and the arts. She brings command over Creativity, Excellence in spoken word, and outward articulation of inner knowledge. </p>
              <p style={{"textAlign":"justify"}}>Goddess Raja Matangi Devi holds the wisdom for mastering the 64 art forms and aids one to reach the pinnacle of one’s own potential in whatever art form or profession one seeks. Matangi is also worshiped in different regions as Matangeshwari, Raja Matangi, Raja Shyamala, Modeshwari, Bhuvaneshwari and Madurai Meenakshi.</p>
              <p style={{"textAlign":"justify"}}><b>“ Goddess Matangi, a fulfiller of every desire of her devotees ” </b> ~ Guru Mithreshiva</p>
              {/* <ul style={{'listStyle':'none'}}>
                <li><span className="green-dot"></span>Poverty</li>
                <li><span className="green-dot"></span>Evil eyes/Black magic</li>
                <li><span className="green-dot"></span>Financial, mental, emotional or physical instability </li>
              </ul> */}
            </div>
          </div>

          <div className="col-md-6">
            <img src="img/whois.png" alt="" className="img-responsive" style={{'padding':'30px'}} onError={(e)=>{e.target.src='/img/placeholder.png'}}/>
          </div>

        </div>
      </div>
    </section>
    <section className="section-divider">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="divider-populated">
              <div className="mantan-m-holder">
                                <div className="mantan-m-line"></div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
                                 <g fill="none" stroke="#44d5bf" strokeMiterlimit="10">
                                    <path d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path>
                                    <path d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path>
                                 </g>
                                 <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path>
                                 <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path>
                                </svg>
                           </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="mandirbg-sec">
      <div className="title-sec mandirbg-title">
        <h1 className="text-center">Matangi Temple Town</h1>
      </div>
      <img src="img/mandir-bg.png" alt="" style={{"objectFit":"contain"}}/>
    </section>

    <section className="section mandir">
      <div className="container-fluid">
        <div className="row">
          
          {/* <div className="snow"></div> */}
          
            <div className="mandir-content">
              <div className="row">
                <div className="col-md-3">
                  <div className="mandirmainblock">
                    <img src="img/mandir.png" alt="" style={{ "padding": "0px 20px" }} className="img-responsive"/>
                    <div className="playbtn1" onClick={onMandir}>
                        <div className="sonar-emitter">
                            <div className="sonar-wave sonar-wave1"></div>
                            <div className="sonar-wave sonar-wave2"></div><span className="fa fa-play"></span>
                        </div>
                    </div>
                  </div>
                  
                </div>
                <div className="col-md-9">
                  <div className="blockmain">
                    <p>The Matangi temple town will be established with the primary purpose to propagate the ultimate wisdom for leading a fulfilled life. This town is planned to comprise Matangi Mandir, Gurukulam, Commune and Herbal Cultivation</p>
                    <br/>
                    <p>Get Your <Link to="/mandir-payment" className="blueyellownobox-button">Divine Blessings</Link> Now</p>
                  </div>
                </div>
                <div className="col-md-12 flexwayblock">
                  <div className="flexway flexleft">
                    <div className="block blockleftright">
                      <h5>Gurukulam</h5>
                      <p>The ancient way of gurukul education has been completely vanquished today as a result of which everyone has forgotten the true purpose of their lives. Modern education has made people focus only on the outer world rather than directing them inwards to realise one’s true potential, purpose of existence and inner consciousness. This can be achieved only with the help of a Guru. The focus of this <b>Gurukulam</b> is to bring back the ancient system of education (Guru-shishya parampara) and culture thereby establishing it as a University to spread this knowledge across the globe.</p>
                    </div>
                  </div>
                  <div className="flexwaycenter">
                    <div className="blockcenter">
                      <h5>Matangi Mandir</h5>
                      <p><b>Matangi Mandir</b> will serve as an energy space adorned with the deity Raja Matangi. Every seeker can easily access the energy and wisdom of the Goddess without any rigorous meditation or Tapas. Raja Matangi bestows supreme intelligence, wisdom to master any art form and spiritual growth to all her devotees.</p>
                    </div>
                    <div className="blockcenter">
                      <h5>Herbal cultivation</h5>
                      <p><b>Herbal Cultivation</b> aims to promote the cultivation of medicinal plants with a resolve to inculcate a healthier lifestyle in mankind. This cultivation will engender not only a healthy humanity but also support the livelihood of farmers and restore natural resources.</p>
                    </div>
                  </div>
                  <div className="flexway flexright">
                    <div className="block blockleftright">
                      <h5>Commune</h5>
                      <p>The <b>Commune</b> is for people who understand that the existential purpose of life is to realise the ultimate Truth. The town will be brimming with the cosmic energy of Goddess Matangi along with the presence of the Guru and his grace which can make one’s journey effortless and ecstatic. The commune will provide the necessary environment needed for one’s spiritual well being. The spiritual growth of a Seeker in the commune will increase exponentially. The commune will be a great platform for people to experience life to its fullest. </p>
                    </div>
                  </div>
                  
                </div>
              </div>
              
              
            </div>
          
        </div>
      </div>
    </section>


    <section className="section-divider">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="divider-populated">
              <div className="mantan-m-holder">
                                <div className="mantan-m-line"></div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
                                 <g fill="none" stroke="#44d5bf" strokeMiterlimit="10">
                                    <path d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path>
                                    <path d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path>
                                 </g>
                                 <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path>
                                 <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path>
                                </svg>
                           </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section aboutdvija">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="title-sec">
              <h1 className="text-center">Guru Mithreshiva</h1>
            </div>
          </div>
          <div className="col-md-6">
            <div className="whois-content">
              <p style={{"textAlign":"justify"}}>Guru Mithreshiva is a mystic, clairvoyant and a powerful leader. He was awakened by the grace of <b>Goddess Raja Matangi Devi </b>at an early age and transformed into a spiritual guru. To millions of people acquainting him, he is nothing but an inspirational master who imparts wisdom with his impeccable yet simple approach towards experiencing life in its truest form. His wisdom helps people transcend beyond the materialistic realm and he articulates it in a manner that can be clearly and easily understood by one and all. </p>
              <p style={{"textAlign":"justify"}}>He is a visionary who envisions humanity to experience life to its fullest. His vision unifies with the law of Universe that is Self-Realisation thereby leading all beings towards a prosperous, peaceful and harmonious world.</p>
              <p style={{"textAlign":"justify"}}>Guru Mithreshiva is a “Bodhisattva” who has devoted his power, energy and life to elevate mankind. As an embodiment of compassion, kindness, and love, he has chosen to live amongst us and propagate the essence of spiritual wisdom.</p>
            </div>
          </div>

          <div className="col-md-6">
            <div>
              <img src="/img/aboutdivija-left.png" alt="" style={{'padding':'30px'}} className="img-responsive radious"/>
            </div>
          </div>

        </div>
      </div>
    </section>
    <section className="section-divider divider-alt">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="divider-populated">
              <div className="mantan-m-holder">
                  <div className="mantan-m-line"></div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
                    <g fill="none" stroke="#44d5bf" strokeMiterlimit="10">
                      <path d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path>
                      <path d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path>
                    </g>
                    <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path>
                    <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path>
                  </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section aboutdvija">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="title-sec">
              <h1 className="text-center">Matangi Foundation</h1>
            </div>
          </div>
          <div className="col-md-4">
            <div className="foundation-box">
            <img src="/img/matangi-foundation.png" alt="" className="img-responsive radious"/>
            </div>
          </div>
          <div className="col-md-8">
            <div className="whois-content">
              <p>Matangi Foundation endeavours to propagate the Universal Truth to society at large and create a healthy, sound humanity in terms of physical, mental, emotional, and inner consciousness. In view to raise every being to their highest potential, Matangi foundation imparts valuable wisdom through various levels of programs, events and social initiatives. Matangi foundation is a Hindu-religious, non profit, volunteer driven organisation based out of Coimbatore, Tamil Nadu, India. People from all walks of life can associate themselves with the foundation.</p>
            </div>
          </div>
          <div className="col-md-12">
            <div>
              <p>The Foundation is a platform that transforms ordinary, mundane life into a paradise for the seeker. Matangi Foundation will be home for people who aspire to achieve and experience the peak of life in all that worldly creation has to offer.</p>
              {/* <Link to="/matangi-foundation" className="blue-button">Learn More</Link> */}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section-divider divider-alt">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="divider-populated">
              <div className="mantan-m-holder">
                  <div className="mantan-m-line"></div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
                    <g fill="none" stroke="#44d5bf" strokeMiterlimit="10">
                      <path d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path>
                      <path d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path>
                    </g>
                    <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path>
                    <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path>
                  </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section blue-background">
      <div className="container">
        <div className="row">

          <div className="col-md-12 vision-block">
          <div className="row">
            <div className="col-md-6">
              <div className="vision-content">
                <h1 className="text-center">Vision</h1>
                <p>Guru Mithreshiva envisions to impart the ultimate wisdom bestowed by Goddess Matangi to all mankind thereby transforming them to reach their highest potential and also awaken their inner consciousness. </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="text-center">
                <img src="img/vision.png" alt="" className="radious" />
              </div>
            </div>
            </div>
            <div className="row">
            <div className="col-md-6">
              <div className="text-center">
                <img src="img/mission.png" alt="" className="radious" style={{ "marginTop":"18px"}}/>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mission-content">
                <h1 className="text-center">Mission</h1>
                <p>To impart wisdom to every being, Matangi foundation offers life transforming experiential programs scientifically designed by the master. The foundation is continuously driving various revolutionary, social projects to enhance people’s lives and to restore nature and its resources. The foundation is also working towards creating a temple town which will help seekers attain the cosmic wealth and unlock their potential to fulfil the purpose of life.</p>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section-divider">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="divider-populated">
              <div className="mantan-m-holder">
                <div className="mantan-m-line"></div>
                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
                  <g fill="none" stroke="#44d5bf" strokeMiterlimit="10">
                    <path d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path>
                    <path d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path>
                  </g>
                  <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path>
                  <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path>
                </svg>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    

    <section className="tabsection">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="text-center">
              <ul className="nav nav-tabs" role="tablist">
                <li className="active">
                  <a href="#tab1" role="tab" data-toggle="tab">Programs</a>
                </li>
                <li>
                  <a href="#tab3" role="tab" data-toggle="tab">Events</a>
                </li>
                <li>
                  <a href="#tab2" role="tab" data-toggle="tab">Projects</a>
                </li>
                <li>
                  <a href="#tab4" role="tab" data-toggle="tab">Gallery</a>
                </li>
              </ul>

                <div className="tab-content top-color-border">
                <div className="tab-pane fade in active" id="tab1">
                  <div className="row">
                    { programLists.length > 0 ? programLists.map((program, pindex) => (
                    <div className="col-md-3" key={pindex}>
                      
                      <div className="program-box" style={{backgroundImage: "url(" + program.banner + ")"}} data-source={program.id} onClick={onClickTile}>
                      <div className="program-imgbox"><img src={ program.image } alt="" onError={(e)=>{e.target.src='/img/placeholder.png'}}/></div> 
                        <p><Link to={"/programs/" + program.id}>{ program.name }</Link></p>
                      </div>
                      
                    </div>
                    )) : (
                      <div className="col-md-3">
                        <div className="program-box" style={{ backgroundImage:"url(img/wisdom/ulchemy-plus-bg.png)" }}>
                          <p>Coming Soon</p>
                        </div>
                      </div>
                    )
                    }
                    
                  </div>
                </div>
                <div className="tab-pane fade" id="tab2">
                  <div className="row">
                  { projects.length > 0 ? projects.map((project, prindex) => (
                    <div className="col-md-3" key={prindex}>
                        
                        <div className="program-box" style={{backgroundImage: "url(" + project.banner + ")"}} data-source={project.link} onClick={onClickSlider}>
                        <div className="program-imgbox"><img src={ project.image } alt="" /></div>
                        <p>{ project.name }</p>
                        </div>
                        
                    </div>
                    )) : (
                        <div className="col-md-3">
                        <div className="program-box" style={{ backgroundImage:"url(img/wisdom/ulchemy-plus-bg.png)" }}>
                            <p>Coming Soon</p>
                        </div>
                        </div>
                    )
                    }
                  </div>
                </div>
                <div className="tab-pane fade" id="tab3">
                  <div className="row">
                    { programevent.length > 0 ? programevent.map((programevent, peindex) => (
                    <div className="col-md-3" key={peindex}>
                      
                      <div className="program-box" style={{backgroundImage: "url(" + programevent.banner + ")"}} data-source={programevent.id} onClick={onClickTile}>
                      <div className="program-imgbox"><img src={ programevent.image } alt="" onError={(e)=>{e.target.src='/img/placeholder.png'}}/></div>
                        <p><Link to={"/programs/" + programevent.id}>{ programevent.name }</Link></p>
                      </div>
                      
                    </div>
                    )) : (
                      <div className="col-md-3">
                        <div className="program-box" style={{ backgroundImage:"url(img/wisdom/ulchemy-plus-bg.png)" }}>
                          <p>Coming Soon</p>
                        </div>
                      </div>
                    )
                    }
                    
                  </div>
                </div>
                <div className="tab-pane fade" id="tab4">
                  <div className="row">
                  <SRLWrapper>
                  { recent && recent.map((recent, steindex, array) => {
                    if (array.length - 1 === steindex) {
                      return (<div className="col-lg-3 col-md-3 col-sm-6" key={steindex}>
                        <div className="vertical-item gallery-item content-absolute text-center">
                          <div className="item-media">
                            <img src={ recent.image } alt={ recent.caption } />
                            <div className="plus-links">
                              <div className="plus-wrap">
                              <Link to={"/gallery/"}>+{albumcount} <br/><span>View All</span></Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>);
                    } else {
                      return (<div className="col-lg-3 col-md-3 col-sm-6" key={steindex}>
                        <div className="vertical-item gallery-item content-absolute text-center">
                          <div className="item-media">
                            <img src={ recent.image } alt={ recent.caption } />
                          </div>
                        </div>
                      </div>); 
                    }
                  })}
                  </SRLWrapper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section-divider divider-alt">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="divider-populated">
              <div className="mantan-m-holder">
                  <div className="mantan-m-line"></div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
                    <g fill="none" stroke="#44d5bf" strokeMiterlimit="10">
                      <path d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path>
                      <path d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path>
                    </g>
                    <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path>
                    <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path>
                  </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    
    <section className="section audiosection grey-background">
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<div className="title-sec">
							<h1 className="text-center">All Upcoming</h1>
						</div>
					</div>

          { eventLists.length > 0 ? (
					<div className="col-md-12">
            <div className="audio-block">
              <div className="slider-btn-prev nav-slider-btn upcomingevent-slider-prev">
                  <span className="fa fa-arrow-left"></span>
              </div>
              <div className="upcomingevent-container">
              <div className="swiper-wrapper">
              { eventLists && eventLists.map((event, eeeindex) => (
                <div className="swiper-slide" key={eeeindex}>
                  <div className="thumb-box">
                    <div className="thumb-img" data-eventid={event.id} data-programid={event.program_id} onClick={handleRegister}>
                      <div className="media-img mediaupcome-img">
                        <img src={ event.event_image } alt="" onError={(e)=>{e.target.src='/img/placeholder.png'}}/>
                      </div>
                      <div className="additional-info" data-eventid={event.id} data-programid={event.program_id} onClick={handleRegister}>
                        <div className="thumb-round">
                          <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37"><g fill="none" stroke="#44d5bf" strokeMiterlimit="10"><path stroke="#44d5bf" d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path><path stroke="#44d5bf" d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path></g><path stroke="#44d5bf" fill="none"  strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path><path stroke="#44d5bf" fill="none"  strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path></svg>
                        </div>
                        
                        <div className="info-share">
                          <p className={ isEventOnWish(event.id) ? 'second wished' : 'second'} onClick={addEvent} data-id={event.id}>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" className="svg-inline--fa fa-heart fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>
                          </p>
                          <p className="first" data-for="share" data-tip="Click to Copy the Link" data-iscapture="true" onClick={ () => copyToClipEventBoard(event.program_id) }><span className="fa fa-share-alt"></span></p>
                        </div>
                        <p className="additional-content">{ event.event_desc && event.event_desc.length > 90 ? event.event_desc.substring(0, 90)+ "..."  : event.event_desc }</p>
                      </div>
                    </div>
                    <div className="thumb-content">
                      <h5 data-eventid={event.id} data-programid={event.program_id} onClick={handleRegister}>{ event.event_name.length > 55 ? event.event_name.substring(0, 30)+ "..."  : event.event_name }</h5>
                      <p>{ event.event_date } <button className="buttonless" data-eventid={event.id} data-programid={event.program_id} onClick={handleRegister}>Register now</button></p>
                    </div>
                  </div>
                </div>
                )) 
              }
              </div>
            </div>
            <div className="slider-btn-next nav-slider-btn upcomingevent-slider-next">
              <span className="fa fa-arrow-right"></span>   
            </div>
            </div>
          </div>
          ) : 
          (
            <div className="col-md-12"> <p className="text-center">No Upcoming Events Found</p></div>
          )}    

				</div>
			</div>
		</section>

    {bottombanner &&
    <section>
      <img src={bottombanner.image} alt="" className="img-responsive" onClick={onClickSlider} data-source={bottombanner.media} style={{'cursor':'pointer', 'display': 'inline-block'}} onError={(e)=>{e.target.src='/img/placeholder.png'}}/>
    </section>
    }
    <section className="section-divider divider-alt">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="divider-populated">
              <div className="mantan-m-holder">
                                <div className="mantan-m-line"></div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
                                 <g fill="none" stroke="#44d5bf" strokeMiterlimit="10">
                                    <path d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path>
                                    <path d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path>
                                 </g>
                                 <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path>
                                 <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path>
                                </svg>
                           </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* <section className="section">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="title-sec">
              <h1 className="text-center">Latest Videos</h1>
            </div>
          </div>
          { videoLists.length > 0 ? videoLists.map((video, vindex) => (
          <div className="col-md-3" key={vindex}>
            <div className="thumb-box">
              <div className="thumb-img">
                <div className="media-img">
                  <img src={ video.image } alt="" onError={(e)=>{e.target.src='/img/placeholder.png'}}/>
                </div>
                <div className="video-info">
                {video.media_time !=='' && (
                  <div className="info-time">
                    <p>{ video.media_time }</p>
                  </div>
                )}
                  <div className="info-share">
                    <p className="first" data-for="share" data-tip="Click to Copy the Link" data-iscapture="true" onClick={ () => copyToClipBoard(video.media) }><span className="fa fa-share-alt"></span></p>

                    <p className={ isMediaOnWish(video.id) ? 'second wished' : 'second'} onClick={addMedia} data-id={video.id}>
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" className="svg-inline--fa fa-heart fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>
                    </p>
                  </div>
                  <div className="playbtn">
                    <div className="sonar-emitter" data-video={ video.media } onClick={onOpenModal}>
                        <div className="sonar-wave sonar-wave1"></div>
                        <div className="sonar-wave sonar-wave2"></div><span className="fa fa-play"></span>
                      </div>
                  </div>
                </div>
              </div>
              <div className="thumb-content">
                <h5>{ video.title.length > 55 ? video.title.substring(0, 40)+ "..."  : video.title }</h5>
              </div>
            </div>
          </div>
          )) : (
            <div className="col-md-12">
              <p className="text-center">No Video Found</p>
            </div>
            )
          }
        </div>
      </div>
    </section> */}

{ videoLists.length > 0 && (
    <section className="section audiosection grey-background">
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<div className="title-sec">
							<h1 className="text-center">Latest Videos</h1>
						</div>
					</div>
					<div className="col-md-12">
            <div className="audio-block">
              <div className="slider-btn-prev nav-slider-btn video-slider-prev">
                  <span className="fa fa-arrow-left"></span>
              </div>
              <div className="video-container">
              <div className="swiper-wrapper">
              { videoLists && videoLists.map((video, vindex) => (
                <div className="swiper-slide video-slide" key={vindex}>
                  <div className="thumb-box">
                    <div className="thumb-img">
                      <div className="media-img mediavideo-img">
                        <img src={ video.image } alt="" onError={(e)=>{e.target.src='/img/placeholder.png'}}/>
                      </div>
                      <div className="video-info">
                      {video.media_time !=='' && (
                        <div className="info-time">
                          <p>{ video.media_time }</p>
                        </div>
                      )}
                        <div className="info-share">
                          <p className="first" data-for="share" data-tip="Click to Copy the Link" data-iscapture="true" onClick={ () => onShareOpenModal(video.media) }><span className="fa fa-share-alt"></span></p>

                          <p className={ isMediaOnWish(video.id) ? 'second wished' : 'second'} onClick={addMedia} data-id={video.id}>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" className="svg-inline--fa fa-heart fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>
                          </p>
                        </div>
                        <div className="playbtn">
                          <div className="sonar-emitter" data-video={ video.media } onClick={onOpenModal}>
                              <div className="sonar-wave sonar-wave1"></div>
                              <div className="sonar-wave sonar-wave2"></div><span className="fa fa-play"></span>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div className="thumb-content">
                      <h5>{ video.title.length > 55 ? video.title.substring(0, 40)+ "..."  : video.title }</h5>
                    </div>
                  </div>
                </div>
                )) 
              }
              </div>
            </div>
            <div className="slider-btn-next nav-slider-btn video-slider-next">
              <span className="fa fa-arrow-right"></span>   
            </div>
            </div>
          </div>
				</div>
			</div>
		</section>
    )}

    <section className="section-divider">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="divider-populated">
              <div className="mantan-m-holder">
                  <div className="mantan-m-line"></div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
                    <g fill="none" stroke="#44d5bf" strokeMiterlimit="10">
                      <path d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path>
                      <path d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path>
                    </g>
                    <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path>
                    <path fill="none" stroke="#44d5bf" strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path>
                  </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    { audioLists.length > 0 && (
    <section className="section audiosection grey-background">
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<div className="title-sec">
							<h1 className="text-center">Latest Audio</h1>
						</div>
					</div>
					<div className="col-md-12">
            <div className="audio-block">
              <div className="slider-btn-prev nav-slider-btn audio-slider-prev">
                  <span className="fa fa-arrow-left"></span>
              </div>
              <div className="audio-container">
              <div className="swiper-wrapper">
              { audioLists && audioLists.map((audio, aindex) => (
                <div className="swiper-slide video-slide" key={aindex}>
                <div className="thumb-box">
                  <div className="thumb-img">
                    <div className="media-img mediavideo-img">
                      <img src={ audio.image } alt="" onError={(e)=>{e.target.src='/img/placeholder.png'}}/>
                    </div>
                    <div className="video-info">
                    {audio.media_time !=='' && (
                      <div className="info-time">
                        <p>{ audio.media_time }</p>
                      </div>
                    )}
                      <div className="info-share">
                        <p className="first" data-for="share" data-tip="Click to Copy the Link" data-iscapture="true" onClick={ () => onShareOpenModal(audio.media) }><span className="fa fa-share-alt"></span></p>

                        <p className={ isMediaOnWish(audio.id) ? 'second wished' : 'second'} onClick={addMedia} data-id={audio.id}>
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" className="svg-inline--fa fa-heart fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>
                        </p>
                      </div>
                      <div className="playbtn">
                        <div className="sonar-emitter" data-video={ audio.media } onClick={onOpenModal}>
                            <div className="sonar-wave sonar-wave1"></div>
                            <div className="sonar-wave sonar-wave2"></div><span className="fa fa-play"></span>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div className="thumb-content">
                    <h5>{ audio.title.length > 55 ? audio.title.substring(0, 40)+ "..."  : audio.title }</h5>
                  </div>
                </div>
                </div>
                )) 
              }
              </div>
            </div>
            <div className="slider-btn-next nav-slider-btn audio-slider-next">
              <span className="fa fa-arrow-right"></span>   
            </div>
            </div>
          </div>
				</div>
			</div>
		</section>
    )}
    
    <Modal open={open} onClose={onCloseModal} center>
      <div className='player-wrapper' dangerouslySetInnerHTML={{__html: videourl }}>
      </div>
    </Modal>
    <Modal open={shareopen} onClose={onShareCloseModal} center>
      <div className='player-wrapper shareblock'>
	  	<a href={"https://api.whatsapp.com/send?text="+sharelink} target="_blank"><img src="/img/whatsapp.png" alt="" className="shareicon"/></a>
		  {/* <a href={"https://www.facebook.com/sharer/sharer.php?u="+sharelink} target="_blank"><img src="/img/facebook.png" alt="" className="shareicon"/></a> */}
      <a href={"https://www.facebook.com/dialog/share?app_id=325006426329429&display=popup&href="+sharelink+"&redirect_uri="+sharelink} target="_blank"><img src="/img/facebook.png" alt="" className="shareicon"/></a>
      </div>
    </Modal>
    <ReactTooltip
      id="share"
      place='bottom'
      multiline={true}
    />
    <ToastContainer/>

    <div id="site-background">
        <div className="layer-wrapper">
            {/* <div className="layer1" style={{ "transform": "translateY(0px)" }}>
                <div className="element2"><img src="img/element1.png" alt="" /></div>
            </div> */}
            <div className="layer2" style={{ "transform": "translateY(68.428px)" }}>
                <div className="element4"><img src="img/element7.png" alt="" /></div>
            </div>
        </div>
    </div>

      
    </div>
    
  );
};

export default Home;
